import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleVinEditor = ({
  tradeId,
  initialVin,
}: {
  tradeId: Trade['id'];
  initialVin: string;
}) => {
  const [vin, setVin] = useState(initialVin);

  const updateVinMutation = useMutation({
    onMutate: async ({ vin }: { vin: string }) => {
      tradesStore.updateTrade(tradeId, {
        vin: vin,
      });
    },
    mutationFn: async ({ vin }: { vin: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/vin`,
        // /api/trades/:trade_id/vin
        {
          vin,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating vin', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleVinChange = useCallback(
    debounce((newVin: string) => {
      updateVinMutation.mutate({ vin: newVin });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (vin === initialVin) return;

    handleVinChange(vin);
  }, [vin]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setVin(e.target.value);
  }, []);

  useEffect(() => {
    setVin(initialVin);
  }, [initialVin]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">VIN</div>
      </div>
      <InlineTextInput
        value={vin}
        onChange={onChange}
        placeholder="Enter VIN"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleVinEditor;
